<!-- 计划详情 -->
<template>
  <div
    class="plan-detail"
    id="plan-detail"
    :class="{ 'custom-plan': planType == 1 }"
    :style="{ height: screenHeight + 'px' }"
  >
    <AppNavBar
      title=""
      :placeholder="true"
      :options="options"
      :backCallback="bindBack"
      v-if="isApp"
    >
      <div slot="right" v-if="!isShare && !isBanner">
        <span class="share iconfont icon-share" @click="bindShare"></span>
        <van-popover
          v-model="showPopover"
          trigger="click"
          placement="bottom-end"
          :offset="[4, 8]"
          get-container="#plan-detail"
          v-if="planType == 1 && isUsed != 1 && !isShare && !isBanner"
        >
          <div class="menu-list">
            <div class="menu-item" @click="bindDel"
              ><span class="del iconfont icon-shanchu"></span>删除</div
            >
          </div>
          <template #reference>
            <span class="more iconfont icon-gengduo1" @click="bindMore"></span>
          </template>
        </van-popover>
      </div>
    </AppNavBar>
    <div
      v-if="planType == 2"
      v-pageBuried
      :data-page-buried="'BG_XTJIHUAXQ_' + id"
    ></div>
    <div v-if="planDetailData" class="plan-wrapper">
      <div class="plan-container">
        <div class="bottom-content">
          <div class="b-title-content">
            <img
              class="b-title-image"
              :src="
                planDetailData.plan_info.cover_img ||
                planDetailData.plan_info.cover_image
              "
              alt=""
            />
            <div class="b-title-right">
              <div class="bt-text" v-if="!showEdit" @click="bindShowEdit"
                ><span class="plan-name">{{ planName }}</span
                ><span
                  class="edit-icon iconfont icon-editor"
                  v-if="!isShare && !isBanner && isApp && planType == 1"
                ></span>
              </div>
              <div class="bt-text edit-title" v-else>
                <input
                  ref="editName"
                  class="edit-input"
                  maxlength="12"
                  placeholder="请输入计划名称"
                  v-model="planName"
                  type="text"
                />
                <span
                  class="iconfont icon-gou"
                  @click="bindEditPlanName"
                ></span>
              </div>
              <div
                class="bt-info"
                v-if="planType == 1 && !isApp && planDetailData.expert_info"
                >由<img
                  class="bt-avatar"
                  :src="planDetailData.expert_info.head_portrait"
                  alt="" /><span class="bt-name">{{
                  planDetailData.expert_info.name
                }}</span
                >编写<img
                  class="bt-icon"
                  :src="planDetailData.expert_info.icon"
                  alt=""
              /></div>
              <div
                class="bt-info"
                @click="bindToCoachPage"
                v-if="planType == 2 && planDetailData.expert_info"
              >
                由<img
                  class="bt-avatar"
                  :src="planDetailData.expert_info.head_portrait"
                  alt=""
                /><span class="bt-name">{{
                  planDetailData.expert_info.name
                }}</span
                >编写</div
              >
              <div class="bt-num" v-if="planDetailData.plan_info.eat_count">
                {{ planDetailData.plan_info.eat_count }}人正在使用</div
              >
            </div>
          </div>
          <div class="edit-info">
            <div class="info-desc" v-if="planDetailData.expert_info"
              >{{ planDetailData.plan_info.introduction }}
            </div>
          </div>
          <div
            class="line-item efficacy-content"
            v-if="planDetailData.efficacy.length"
          >
            <div class="line-gray">功效</div>
            <div class="line-bottom">
              <div class="effect-scroll">
                <div class="effect-list">
                  <div
                    class="effect-item"
                    v-for="(item, index) in planDetailData.efficacy"
                    :key="index"
                  >
                    <img class="effect-item-icon" :src="item.image" />
                    <div class="effect-item-name">{{ item.title }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="line-item" v-if="planDetailData.element.length">
            <div class="line-gray">营养元素</div>
            <div class="line-bottom">
              <div class="bottom-text"
                ><span
                  v-for="(item, index) in planDetailData.element"
                  :key="index"
                  >{{ item.title
                  }}{{
                    index < planDetailData.element.length - 1 ? '、' : ''
                  }}</span
                >
              </div>
            </div>
          </div>
          <div
            class="line-item"
            v-if="planDetailData.plan_info.prev_effective_period"
          >
            <div class="line-gray">预计见效期</div>
            <div class="line-bottom">
              <div class="bottom-text">{{
                planDetailData.plan_info.prev_effective_period
              }}</div>
            </div>
          </div>
          <div class="line-item" v-if="planDetailData.able_crowds.length">
            <div class="line-gray">适用人群</div>
            <div class="line-bottom">
              <div class="bottom-text"
                ><span
                  v-for="(item, index) in planDetailData.able_crowds"
                  :key="index"
                  >{{ item
                  }}{{
                    index < planDetailData.able_crowds.length - 1 ? '、' : ''
                  }}</span
                >
              </div>
            </div>
          </div>
          <div class="line-item" v-if="planDetailData.disable_crowds.length">
            <div class="line-gray">禁用人群</div>
            <div class="line-bottom">
              <div class="bottom-text"
                ><span
                  v-for="(item, index) in planDetailData.disable_crowds"
                  :key="index"
                  >{{ item
                  }}{{
                    index < planDetailData.disable_crowds.length - 1 ? '、' : ''
                  }}</span
                >
              </div>
            </div>
          </div>
          <div class="line-item" v-if="planDetailData.product_list.length">
            <div class="line-gray">计划详情</div>
            <div class="line-bottom">
              <div class="plan-list">
                <div
                  class="plan-item"
                  v-for="(item, index) in planDetailData.product_list"
                  :key="index"
                  @click="bindClickTonicItem(item)"
                >
                  <div class="item-left">
                    <img class="item-icon" :src="item.image" alt="" />
                    <img class="item-brand" :src="item.brand_img" alt="" />
                  </div>
                  <div class="item-center">
                    <div class="item-name">{{ item.p_title }}</div>
                    <div class="tag-list"
                      ><span
                        class="tag-item"
                        v-for="(item1, index1) in item.efficacy"
                        :key="index1"
                        >{{ item1.title }}</span
                      >
                    </div>
                    <div class="item-space"></div>
                    <div class="item-b-content">
                      <div class="item-num">
                        {{ item.every_times_num }}{{ item.min_unit_txt }}/次·{{
                          item.daily_times
                        }}次/日·{{ item.take_suggested_time_txt }}
                      </div>
                      <div class="item-btn">
                        <div class="detail-btn"
                          >了解详情<span class="iconfont icon-you"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 组合购买 -->
                <div
                  class="group-buy"
                  v-if="planDetailData.plan_info.router"
                  @click="bindGoupBuy"
                  v-buried
                  data-buried="BG_ZUHEBUY"
                  v-clickBuried
                  :data-eventv="'BG_ZUHEBUY_' + id"
                  :data-click-eventv="'CLICK_ZUHEBUY_' + id"
                  data-click-buried="CLICK_ZUHEBUY"
                >
                  <WxOpenLaunchApp :extinfo="extinfo" />
                  <div
                    class="grou-less-prize"
                    v-if="planDetailData.plan_info.reduction_price"
                    >立省¥{{ planDetailData.plan_info.reduction_price }}</div
                  >
                  <span class="iconfont icon-gouwuche1"></span>一键组合购买
                </div>
              </div>
            </div>
          </div>
          <div class="disclaimers" @click="bindShowDisclaimers">免责声明</div>
        </div>
      </div>
      <div class="fixed-btn" v-if="!isApp">
        <div class="app-btn">
          上betterWE星球，用同款计划<span class="iconfont icon-you"></span>
          <WxOpenLaunchApp :extinfo="extinfo" />
        </div>
      </div>
      <div class="fixed-btn white-btn" v-else>
        <div class="create-btn" v-if="isUsed" @click="bindClickUsed"
          >正在使用</div
        >
        <div
          @click="bindStartPlan"
          class="create-btn"
          v-else
          v-buried
          :data-buried="'BG_BUTTON_XTJIHUAXQ_QIDONG_' + id"
          v-clickBuried
          :data-click-buried="[
            'CLICK_BUTTON_XTJIHUAXQ_QIDONG_' + id,
            'CLICK_BUTTON_XTJIHUAXQ_QIDONG'
          ]"
        >
          启用计划</div
        >
      </div>
      <van-popup
        v-model="showTonicDetail"
        position="bottom"
        round
        class="plan-list-popup"
      >
        <TonicDetail
          :id="tonicId"
          v-if="showTonicDetail"
          @close="showTonicDetail = false"
        />
      </van-popup>
      <van-popup v-model="showDisclaimers" position="bottom" round>
        <DisclaimersComponent />
      </van-popup>
      <van-overlay :show="showCreateLoading" z-index="5002">
        <CreateLoading :type="loadingType" />
      </van-overlay>
      <CommonToast
        v-model="showCommonToast"
        :options="commonToastData"
        @confirm="bindDefaultConfirm"
        @cancel="bindDefaultCancel"
      />
    </div>
    <div class="not-data" v-if="errorMessage">
      <img
        class="empty-image"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/37ea2493f314e6118cec06f305121b6b.png"
        alt=""
      />
      <div class="text">{{ errorMessage }}</div>
    </div>
    <!-- 分享组件 -->
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @cancel="bindCancel"
      @select="bindSelect"
      :qrcodeUrl="qrcodeUrl"
    />
  </div>
</template>

<script>
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
import TonicDetail from './components/tonic-detail.vue'
import DisclaimersComponent from './components/disclaimers.vue'
import CreateLoading from './components/create-loading.vue'
import CommonToast from './components/common-toast.vue'
import AppNavBar from '@/components/app/nav-bar/index.vue'
import ShareComponent from '@/components/app/share/share.vue'
import { eventObj } from '@/components/app/share/share-method.js'
export default {
  components: {
    TonicDetail,
    DisclaimersComponent,
    CreateLoading,
    CommonToast,
    AppNavBar,
    ShareComponent,
    WxOpenLaunchApp
  },
  data() {
    return {
      extinfo: '/home?pageTag=0',
      isShare: false,
      isBanner: false,
      isApp: false,
      options: {
        barBackgroundColor: 'rgba(0,0,0,0)'
      },
      showPopover: false,
      actions: [{ text: '删除' }],
      showShare: false,
      planName: '',
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
          name: '复制链接',
          id: 3,
          copy: true,
          className: 'share-copy-btn'
        }
      ],
      shareOptions: {
        desc: '快来打开看看，加速燃脂、抗炎抗氧的秘密就在这里哦！',
        title: '向你分享了一个营养闹钟计划！',
        thumbnail:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0a8865341b353336bfe340f5e9ebf087.png' // 分享的缩略图的url
      },
      qrcodeUrl: '',
      showDisclaimers: false,
      showTonicDetail: false,
      tonicId: 0,
      showCreateLoading: false,
      showCommonToast: false,
      commonToastData: null,
      planDetailData: null,
      loadingType: 2,
      errorMessage: '',
      showEdit: false,
      screenHeight: window.innerHeight
    }
  },
  computed: {
    fixedBtnText() {
      let btnText = ['启用计划', '正在使用']
      let status = +this.planDetailData?.is_used
      return btnText[status]
    },
    isUsed() {
      return this.planDetailData?.is_used || false
    }
  },
  created() {
    this.isApp = this.$betterwe.isApp()
    this.extinfo = '/web?url=' + encodeURIComponent(location.href)
    this.isShare = !!this.$route.query?.share
    this.isBanner = !!this.$route.query?.banner
    this.planType = +this.$route.query?.planType
    this.id = this.$route.query?.id
    this.qrcodeUrl = location.href + '&share=1'
    switch (this.planType) {
      case 1:
        this.getCustomPlanDetail()
        break
      case 2:
        this.getPlanDetail()
        break
    }
  },
  mounted() {
    this.addScrollEvent()
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    bindCancel() {
      this.showShare = false
    },
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      let name =
        this.$store.state.userInfo.user &&
        this.$store.state.userInfo.user.truename
      shareOptions.title = name + '向你分享了一个营养闹钟计划！'
      shareOptions.thumbnail =
        this.planDetailData.plan_info.cover_image ||
        this.planDetailData.plan_info.cover_img
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        // 分享图片到微信好友 图片 -> base64
        case 3:
          break
      }
    },
    bindDel() {
      this.showPopover = false
      this.commonToastData = {
        title: '删除计划',
        message: '您确定要删除该自定义计划吗？',
        confirmButtonText: '确认删除'
      }
      this.bindDefaultConfirm = this.deletePlan
      this.showCommonToast = true
    },
    bindClickUsed() {
      if (this.isShare || this.isBanner) {
        this.commonToastData = {
          title: '查看计划',
          message: '您正在使用该计划,是否回到营养闹钟首页查看?',
          confirmButtonText: '确定'
        }
        this.bindDefaultConfirm = this.bindToHome
        this.showCommonToast = true
      }
    },
    bindToHome() {
      this.$router.replace('/nutrition-clock/index')
    },
    bindEditPlanName() {
      this.showEdit = false
      if (
        this.planName === '' ||
        this.planName === this.planDetailData.plan_info.title
      ) {
        this.planName = this.planDetailData.plan_info.title
        return
      }
      console.log('编辑名称')
      this.postEditPlanName(this.planName)
    },
    async postEditPlanName(planName) {
      let params = {
        plan_id: this.id,
        title: planName
      }
      let res = await this.$http
        .postBaseApp('api/v1/TonicPlanOperate/editPlanTitle', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('修改成功')
          this.planDetailData.plan_info.title = planName
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindShowEdit() {
      if (!this.isShare && !this.isBanner && this.isApp) {
        this.showEdit = true
        this.$nextTick(() => {
          this.$refs.editName?.focus()
        })
      }
    },
    async deletePlan() {
      let params = {
        plan_id: this.id
      }
      let res = await this.$http
        .postBaseApp('api/v1/TonicPlanOperate/delPlan', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('删除成功')
          setTimeout(() => {
            this.$router.go(-1)
          }, 400)
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindShare() {
      this.showShare = true
    },
    bindMore() {
      this.showMore = true
    },
    bindToCoachPage() {
      let isDietitian = this.planDetailData.expert_info.is_dietitian
      let id = this.planDetailData.expert_info.id
      let edId = this.planDetailData.expert_info.ed_id
      if (isDietitian) {
        this.$betterwe.jumpRoute('/dietitianDetails?id=' + edId + '&isLogin=1')
      } else {
        this.$betterwe.jumpRoute('/starDetails?id=' + id)
      }
    },
    addScrollEvent() {
      setTimeout(() => {
        window.addEventListener('scroll', this.bindScroll)
      }, 100)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      let scrollTop =
        e.target.documentElement.scrollTop ||
        e.target.body.scrollTop ||
        e.target.pageYOffset
      if (scrollTop >= 100) {
        this.options = {
          barBackgroundColor: '#fff',
          color: 'rgba(0,0,0.8)'
        }
      } else {
        let p = parseFloat((scrollTop / 100).toFixed(2))
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, ' + p + ')',
          color: 'rgba(0,0,0.8)'
        }
      }
    },
    bindBack() {
      if (this.isShare) {
        this.$router.replace('/nutrition-clock/plan-list')
      } else {
        this.$http.appBack()
      }
    },
    bindShowDisclaimers() {
      this.showDisclaimers = true
    },
    bindClickTonicItem(item) {
      this.tonicId = item.product_id
      this.showTonicDetail = true
    },
    /* 获取模板计划详情 */
    async getPlanDetail() {
      let params = {
        template_id: this.id
      }
      let url = this.isApp
        ? 'api/v1/TonicShow/tonicTemplatePlanDetail'
        : 'api/v1/TonicShow/tonicTemplatePlanDetailShare'
      let res = await this.$http.getBaseApp(url, params)
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.planDetailData = res.data
          this.planName = res.data.plan_info.title
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getCustomPlanDetail() {
      let params = {
        plan_id: this.id
      }
      let url = this.isApp
        ? 'api/v1/TonicShow/tonicUserPlanDetail'
        : 'api/v1/TonicShow/tonicUserPlanDetailShare'
      let res = await this.$http.getBaseApp(url, params)
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.planDetailData = res.data
          this.planName = res.data.plan_info.title
        } else {
          this.errorMessage = res.msg
        }
      }
    },
    bindStartPlan() {
      if (this.isUsed) {
        return
      }
      if (this.curPlan) {
        this.commonToastData = {
          title: '替换计划',
          message: '目前有正在进行的计划，确认要替换吗？',
          confirmButtonText: '确认替换'
        }
        this.bindDefaultConfirm = this.stopPlan
        this.showCommonToast = true
      } else if (this.curPlan === null) {
        this.startPlan()
      } else {
        this.getUserPlan()
      }
    },
    //关闭计划
    async stopPlan() {
      this.showCommonToast = false
      let params = {
        plan_id: this.curPlan.id
      }
      let res = await this.$http
        .postBaseApp('api/v1/TonicPlanOperate/stopPlan', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.startPlan()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    /* 开始计划 */
    startPlan() {
      if (this.planType == 1) {
        if (this.isShare || this.isBanner) {
          this.copyCustomPlan()
        } else {
          this.startCustomPlan()
        }
      } else {
        this.startTemplatePlan()
      }
    },
    /* 复制自定义计划 */
    async copyCustomPlan() {
      this.showCreateLoading = true
      let params = {
        plan_id: this.id
      }
      /* 动画播放时间 */
      let promise1 = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 3000)
      })
      let promise2 = this.$http.postBaseApp(
        'api/v1/TonicPlanOperate/copyCustomPlan',
        params
      )
      let res = await Promise.all([promise1, promise2]).catch(() => {
        this.showCreateLoading = false
      })
      if (res) {
        let res1 = res[1].data
        if (res1.code == 200) {
          /* 更新计划数据id */
          // this.$store.commit("nutritionClock/setPlanDataId", this.id);
          this.backHome()
        } else {
          this.$toast(res1.msg)
          this.showCreateLoading = false
        }
      }
    },
    async startCustomPlan() {
      this.showCreateLoading = true
      let params = {
        plan_id: this.id
      }
      /* 动画播放时间 */
      let promise1 = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 3000)
      })
      let promise2 = this.$http.postBaseApp(
        'api/v1/TonicPlanOperate/startPlan',
        params
      )
      let res = await Promise.all([promise1, promise2]).catch(() => {
        this.showCreateLoading = false
      })
      if (res) {
        let res1 = res[1].data
        if (res1.code == 200) {
          /* 更新计划数据id */
          this.$store.commit('nutritionClock/setPlanDataId', this.id)
          this.backHome()
        } else {
          this.$toast(res1.msg)
          this.showCreateLoading = false
        }
      }
    },

    /* 开启模板计划 */
    async startTemplatePlan() {
      this.showCreateLoading = true
      let params = {
        template_id: this.id
      }
      /* 动画播放时间 */
      let promise1 = new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve()
        }, 3000)
      })
      let promise2 = this.$http.postBaseApp(
        'api/v1/TonicPlanOperate/addTemplatePlan',
        params
      )
      let res = await Promise.all([promise1, promise2]).catch(() => {
        this.showCreateLoading = false
      })
      if (res) {
        let res1 = res[1].data
        if (res1.code == 200) {
          /* 更新计划数据id */
          let planId = res1.data?.plan_id
          if (planId) {
            this.$store.commit('nutritionClock/setPlanDataId', planId)
          }
          this.backHome()
        } else {
          this.$toast(res1.msg)
          this.showCreateLoading = false
        }
      }
    },
    /* 返回首页 */
    backHome() {
      this.$store.commit('nutritionClock/setShowActivityToast', true)
      if (this.isShare || this.isBanner) {
        this.$router.replace('/nutrition-clock/index')
      } else {
        this.$http.appBack()
      }
    },
    /* 获取用户进行中的计划 */
    async getUserPlan() {
      let res = await this.$http
        .postBaseApp('api/v1/TonicPlanOperate/getUserInprocessPlan', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data) {
            this.curPlan = res.data || null
            this.bindStartPlan()
          } else {
            this.startPlan()
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindDefaultConfirm() {
      this.showCommonToast = false
    },
    bindDefaultCancel() {
      this.showCommonToast = false
    },
    bindGoupBuy() {
      let route = this.planDetailData.plan_info.router
      if (this.$betterwe.isApp() && route) {
        this.$betterwe.jumpRoute(route)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.menu-list {
  background: #f1f1f1;
  padding: 6px 15px;

  .menu-item {
    white-space: nowrap;

    .del {
      margin-right: 4px;
    }
  }
}

::v-deep .van-popover__arrow {
  color: #f1f1f1;
}

::v-deep .van-popover__content {
  border-radius: 4px;
}

.custom-plan {
  .b-title-content {
    border-bottom: none !important;
    padding-bottom: 0px !important;
  }
}

.plan-detail {
  color: rgba(0, 0, 0, 0.8);
  z-index: 1;
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .plan-wrapper {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }

  ::v-deep .van-popover__arrow {
    right: 2px;
  }

  .share {
    margin-right: 16px;
  }

  .plan-container {
    height: 100%;
    overflow-y: scroll;

    .banner {
      position: relative;
      z-index: -1;
      width: 100%;
      height: 184px;
      object-fit: cover;
      margin-bottom: -12px;
    }

    .bottom-content {
      box-sizing: border-box;
      min-height: calc(100vh - 172px);
      padding: 20px;
      @include paddingBottom(78px);
      background: linear-gradient(
        180deg,
        #ffffff 0px,
        #f9f9f9 328px,
        #f9f9f9 100%
      );
      border-radius: 12px 12px 0px 0px;

      .b-title-content {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 20px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);

        .b-title-image {
          border-radius: 6px;
          overflow: hidden;
          width: 100px;
          height: 100px;
          object-fit: cover;
          margin-right: 10px;
        }

        .b-title-right {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          font-size: 12px;
          color: rgba(0, 0, 0, 0.7);
          line-height: 17px;

          .bt-text {
            margin-bottom: 5px;
            font-family: PingFangSC, PingFang SC;
            font-weight: bold;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.8);
            line-height: 26px;
            display: flex;
            align-items: center;
            display: flex;
            align-items: center;

            .plan-name {
              max-width: 200px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .edit-icon {
              margin-left: 10px;
              font-size: 18px;
              color: rgb(51, 51, 51);
            }
          }

          .edit-title {
            height: 26px;
            display: flex;
            align-items: center;

            .edit-input {
              height: 26px;
              line-height: 26px;
              padding: 0;
              color: rgba(0, 0, 0, 0.5);
              border: none;
              outline: none;
              width: 150px;
              box-sizing: border-box;
            }

            .edit-input::placeholder {
              font-size: 14px;
            }

            .iconfont {
              margin-left: 10px;
              width: 40px;
              height: 26px;
              box-sizing: border-box;
              text-align: center;
              justify-content: center;
            }
          }

          .bt-info {
            display: flex;
            align-items: center;
          }

          .bt-icon {
            margin-left: 6px;
            height: 16px;
          }

          .bt-avatar {
            width: 14px;
            height: 14px;
            object-fit: cover;
            border-radius: 50%;
            overflow: hidden;
            margin: 0px 3px;
          }

          .bt-name {
            color: rgba(171, 112, 36, 1);
          }

          .bt-num {
            margin-top: 10px;
            font-size: 12px;
            color: rgba(0, 0, 0, 0.5);
            line-height: 17px;
          }
        }
      }

      .edit-info {
        margin-bottom: 20px;

        .info-desc {
          padding-top: 14px;
          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          color: rgba(0, 0, 0, 0.5);
          line-height: 20px;
        }
      }

      .line-item {
        .line-gray {
          padding: 0px 12px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          height: 30px;
          background: #f1f1f1;
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFangSC, PingFang SC;
          font-weight: bold;
          line-height: 30px;
        }

        .line-bottom {
          padding-bottom: 20px;

          .bottom-text {
            margin-top: 15px;
            padding-left: 12px;
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            color: rgba(0, 0, 0, 0.5);
            line-height: 20px;
          }
        }
      }

      .effect-scroll {
        padding-top: 15px;
        overflow-x: scroll;

        .effect-list {
          display: inline-flex;
          flex-wrap: nowrap;

          .effect-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
            margin-right: 20px;

            .effect-item-icon {
              width: 40px;
              height: 40px;
              object-fit: contain;
              margin-bottom: 13px;
            }

            .effect-item-name {
              width: 50px;
              text-align: center;
              font-size: 12px;
              font-family: PingFangSC, PingFang SC;
              color: rgba(0, 0, 0, 0.5);
              line-height: 17px;
            }
          }

          .effect-item:last-child {
            margin-right: 0;
          }
        }
      }

      .plan-list {
        margin-top: 11px;
        background: #ffffff;
        border-radius: 6px;
        padding: 14px 8px 20px;

        .plan-item {
          display: flex;
          align-items: flex-start;
          margin-bottom: 30px;
          .item-left {
            position: relative;
            width: 90px;
            height: 90px;
            background: #d8d8d8;
            border-radius: 6px;
            margin-right: 13px;

            .item-icon {
              width: 100%;
              height: 100%;
              border-radius: 6px;
              overflow: hidden;
              object-fit: cover;
            }

            .item-brand {
              position: absolute;
              left: 0;
              top: 0;
              width: 45px;
              height: 15px;
              object-fit: cover;
              border-radius: 6px 0px 6px 0px;
            }
          }

          .item-center {
            min-height: 90px;
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            align-items: stretch;
            justify-content: space-between;

            .item-name {
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: bold;
              color: rgba(0, 0, 0, 0.8);
              line-height: 20px;
              margin-bottom: 4px;
            }

            .item-space {
              flex: 1;
              flex-shrink: 0;
              overflow: hidden;
            }

            .tag-list {
              display: flex;
              flex-wrap: wrap;

              .tag-item {
                white-space: nowrap;
                padding: 0px 3px;
                font-size: 9px;
                background: rgba(254, 248, 225, 1);
                font-size: 10px;
                font-family: PingFangSC, PingFang SC;
                color: #fe8b1a;
                line-height: 14px;
                border-radius: 2px;
                margin-right: 8px;
                margin-bottom: 4px;
              }
            }

            .item-b-content {
              display: flex;
              align-items: flex-end;
              justify-content: space-between;

              .item-num {
                margin-top: 4px;
                font-size: 10px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.5);
                line-height: 14px;
              }

              .item-btn {
                display: flex;
                align-items: center;
                justify-content: center;

                .detail-btn {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 10px;
                  font-family: PingFangSC, PingFang SC;
                  color: #00cddf;
                  line-height: 14px;

                  .iconfont {
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
        .plan-item:last-child {
          margin-bottom: 0;
        }
      }

      .disclaimers {
        width: 50px;
        text-align: center;
        margin: 0 auto;
        font-size: 10px;
        font-family: PingFangSC, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 14px;
      }
    }
  }

  .efficacy-content {
  }

  .white-btn {
    background: #ffffff;
  }

  .fixed-btn {
    position: absolute;
    z-index: 999;
    width: 100%;
    left: 0;
    bottom: 0;
    box-sizing: border-box;
    padding: 10px 20px 5px;
    @include paddingBottom(5px);

    .create-btn {
      text-align: center;
      height: 48px;
      line-height: 48px;
      font-size: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #ffffff;
      background: #03d4e6;
      border-radius: 24px;
    }
  }

  .app-btn {
    position: relative;
    width: 335px;
    height: 48px;
    background: #03d4e6;
    box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.12);
    border-radius: 24px;
    font-weight: bold;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .not-data {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: rgba(0, 0, 0, 0.5);

    .empty-image {
      width: 214px;
      height: 112px;
    }

    .text {
      text-align: center;
      width: 300px;
    }
  }
  .group-buy {
    margin-top: 16px;
    position: relative;
    height: 38px;
    background: linear-gradient(324deg, #373a56 0%, #565e7a 100%);
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
    .iconfont {
      width: 20px;
      height: 20px;
      font-size: 18px;
      line-height: 20px;
      text-align: center;
      font-weight: normal;
      margin-right: 5px;
      color: #fff;
    }
    .grou-less-prize {
      position: absolute;
      right: 54px;
      top: 0;
      transform: translate(0%, -50%);
      height: 18px;
      line-height: 18px;
      background: linear-gradient(220deg, #fc4444 0%, #ffa154 100%);
      border-radius: 8px 8px 8px 0px;
      padding: 0px 6px;
      font-weight: bold;
      font-size: 10px;
      color: #ffffff;
    }
  }
}
</style>
